import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e076932"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]

import { onBeforeMount, watch, ref } from "vue"
import { getMapConfig, getBasemap2dById } from "@/api/map"
import { createMapView } from "@/modules/arcgisAPI"
import { useMapStore } from "@/store/modules/map"
import appConfig from "@/modules/appConfig"
import { Toast } from "vant"
import { useRoute } from "vue-router"

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const mapStore = useMapStore()
const route = useRoute()
const id = ref("")

const creatMapByApi = async () => {
  const map = (window as any).map
  const name = map.apiParams.CGCS2000
  const mapInitParam: any = await getMapConfig(name)
  if (mapInitParam) {
    appConfig.setMapInitParam(mapInitParam)
    const base2DMapCategoryId = mapInitParam?.base2DMapCategoryId
    if (!base2DMapCategoryId) {
      Toast("请关联二维地图参数")
      mapStore.setGlobalLoading(false)
      return
    }

    const mapConfigData: any = await getBasemap2dById(base2DMapCategoryId)
    if (mapConfigData) {
      const baseMapList: any = []
      mapConfigData.children.forEach((item: any) => {
        // 二维底图切换需用到
        const param: any = {
          displayName: item.displayName,
          children: []
        }
        item.base2DMaps.forEach(async (element: any) => {
          const mapLayer = { ...element.mapLayer }
          mapLayer.layerType = element.mapLayer.layerConfig.layerType
          mapLayer.id = element.mapLayer.id
          param.children.push(mapLayer)
        })
        baseMapList.push(param)
      })
      appConfig.setBaseMap(baseMapList)
      createMapView(id.value)
    }
  }
}
const creatMapByConfig = () => {
  if (!appConfig.mapInitParam) {
    const map = (window as any).map
    mapStore.setViewId(id.value)
    appConfig.setMapInitParam(map.localMapConfig.mapInitParam)
    appConfig.setBaseMap(map.localMapConfig.baseMap)
  }
  createMapView(id.value)
}

const setId = () => {
  if (route.path === "/resource/detail") {
    id.value = "detail-id"
  } else {
    id.value = "resource-id"
  }
  appConfig.setId(id.value)
}

const init = () => {
  const map = (window as any).map
  if (map.byApi) {
    // 通过api获取地图参数来初始化地图
    creatMapByApi()
  } else {
    // 通过本地配置获取地图参数来初始化地图
    creatMapByConfig()
  }
}

onBeforeMount(() => {
  setId()
  init()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: id.value,
    class: "viewDiv"
  }, null, 8, _hoisted_1))
}
}

})